// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._8\\+LTAaZQ{display:flex;flex-direction:column;gap:max(2rem,min(2.08vw,2.5rem))}._6K8u15Wj{display:grid;grid-template-columns:repeat(auto-fit,minmax(21.88rem,1fr));grid-gap:max(.5rem,min(.83vw,1rem));gap:max(.5rem,min(.83vw,1rem))}.wn3IEDnb{background:var(--color-bg-600);border-radius:max(1.13rem,min(1.67vw,2rem));display:flex;flex-direction:column;gap:max(1.13rem,min(1.67vw,2rem));padding:max(1.5rem,min(2.08vw,2.5rem))}.IxN4bUoL{font-size:max(1.5rem,min(1.56vw,1.88rem));font-weight:600;line-height:1.07}.VdbZ2nJ2{height:max(12.5rem,min(20.83vw,25rem));-o-object-fit:contain;object-fit:contain;width:100%}.NQRrOL7C{font-size:max(.88rem,min(.94vw,1.13rem));line-height:1.44;margin-top:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "_8+LTAaZQ",
	"cards": "_6K8u15Wj",
	"card": "wn3IEDnb",
	"cardTitle": "IxN4bUoL",
	"cardImg": "VdbZ2nJ2",
	"cardText": "NQRrOL7C"
};
module.exports = ___CSS_LOADER_EXPORT___;
